import { type FormikErrors } from 'formik';
import { type TicketDetailsValues, type TicketFieldValue, type TicketFormField } from './_models';

const REQUIRED_MESSAGE = 'Obrigatório';

export function validateTicketDetails(
  store: string,
  description: string,
  fields: TicketFieldValue[],
  form: TicketFormField[],
): FormikErrors<TicketDetailsValues> {
  const errors: FormikErrors<TicketDetailsValues> = {};
  if (!store) errors.store = REQUIRED_MESSAGE;
  if (form.length === 0 && !description.trim()) errors.description = REQUIRED_MESSAGE;

  const fieldErrors = form.map((formField) => {
    const fieldValue = fields.find((item) => item.label === formField.label)?.value ?? '';
    const isMissing = formField.required && !fieldValue.trim();
    return isMissing ? { value: REQUIRED_MESSAGE } : {};
  });
  const hasFieldError = fieldErrors.some((fieldError) => fieldError.value);
  if (hasFieldError) errors.fields = fieldErrors;

  return errors;
}
